module.exports = __webpack_public_path__ + "img/Misie-mob..c4eaefdb.svg";